/**
 * Parse session id and token from a Garmin LiveTrack share URL or pasted text.
 *
 * @param {string} input
 * @returns {{ sessionId: string, token: string } | null}
 */
export function parseLiveTrackShare(input) {
  if (!input || typeof input !== 'string') return null;
  const m = input.trim().match(
    /livetrack\.garmin\.com\/session\/([0-9a-f-]{36})\/token\/([A-Fa-f0-9]+)/i
  );
  if (!m) return null;
  return { sessionId: m[1].toLowerCase(), token: m[2].toUpperCase() };
}
